import { useLoaderData } from 'react-router-dom';

import ThreadDetails from 'src/components/organisms/CommunityThreadDetails/ThreadDetails';
import { CommunityLayout } from 'src/components/templates/Layouts/CommunityLayout';
import { convertToSlug } from 'src/core/utils/urlUtil';
import type { Thread, Comment } from 'src/mapper/threadMapper';
import { MetaTag } from 'src/modules/meta/MetaTag';
import { getMetaData } from 'src/modules/meta/meta';
import { ROUTER_PATHS } from 'src/paths';
import { useTrackPageView } from 'src/provider/analytics';
import { useConfig } from 'src/provider/config';
import { useUrlThreadReloader } from 'src/provider/page';
import ThreadDetailProvider from 'src/provider/threadDetail';

export interface ThreadDetailsData {
  thread: Thread;
  comments: Comment[];
  init: boolean;
  isAuthenticated: boolean;
}

export function ThreadDetailsPage() {
  const { thread } = useLoaderData() as ThreadDetailsData;
  const { slug, title } = thread;
  const { language, absoluteUrl, brand } = useConfig();

  const categoryName = thread?.category?.name;
  const threadId = thread?.id;
  useTrackPageView(categoryName, threadId);
  useUrlThreadReloader(slug, convertToSlug(categoryName));

  return (
    <CommunityLayout>
      <MetaTag
        {...getMetaData({
          page: ROUTER_PATHS.communityThreadDetails,
          threadTitle: title,
          language,
          absoluteUrl,
          brand,
        })}
      />
      <ThreadDetailProvider thread={thread}>
        <ThreadDetails />
      </ThreadDetailProvider>
    </CommunityLayout>
  );
}
